import React, { useCallback, useContext } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

// import { unsubscribeRealtimeUpdates } from '../../system/firebase';
import { AppContext } from '../../common/contexts';
import { LayoutContext } from '../../common/contexts';
import {
    DASHBOARD_MY_PROFILE,
    DASHBOARD_MY_JOBS,
    DASHBOARD_MY_SETTINGS,
    DASHBOARD_MY_MESSAGES,
    DASHBOARD_MY_CALENDAR,
    DASHBOARD_TALENT_CENTER,
    // BASE_URL,
    DASHBOARD_ID_MY_SETTINGS,
} from '../../common/constants';

import NavigationButton from '../../dashboard/subComponents/NavigationButton';
import PhotoSection from '../../dashboard/subComponents/PhotoSection';
import Footer from '../../dashboard/subComponents/Footer';

import _get from 'lodash/get';

const styles = theme => ({
    root: {
        backgroundColor: '#FAFAFC',
        // width: '256px',
        height: '100%',
        textAlign: 'center',
        // marginLeft: '64px',
        // marginRight: '64px',
        display: 'flex',
        flexDirection: 'column',
        [theme.breakpoints.up('xl')]: { width: '256px', marginLeft: '64px' },
        [theme.breakpoints.down('lg')]: { marginTop: 16 },
    },
});

const getDefns = params => {
    const { props, profilePicUrl, dashboard, setCurrentDashboard, handleClickNonMySettingsButton } = params;
    const {
        classes: { root: rootCls },
    } = props;

    const defns = {
        root: {
            className: rootCls,
        },
        photoSection: {
            photoUrl: profilePicUrl,
        },
        myProfileButton: {
            label: DASHBOARD_MY_PROFILE,
            selected: dashboard === DASHBOARD_MY_PROFILE,
            onClick: handleClickNonMySettingsButton,
        },
        myJobsButton: {
            label: DASHBOARD_MY_JOBS,
            selected: dashboard === DASHBOARD_MY_JOBS,
            onClick: handleClickNonMySettingsButton,
        },
        mySettingsButton: {
            label: DASHBOARD_MY_SETTINGS,
            selected: dashboard === DASHBOARD_MY_SETTINGS,
            onClick: setCurrentDashboard.bind(null, DASHBOARD_ID_MY_SETTINGS),
        },
        talentCenterButton: {
            label: DASHBOARD_TALENT_CENTER,
            selected: dashboard === DASHBOARD_TALENT_CENTER,
            onClick: handleClickNonMySettingsButton,
        },
        myMessagesButton: {
            label: DASHBOARD_MY_MESSAGES,
            selected: dashboard === DASHBOARD_MY_MESSAGES,
            onClick: handleClickNonMySettingsButton,
        },
        myCalendarButton: {
            label: DASHBOARD_MY_CALENDAR,
            selected: dashboard === DASHBOARD_MY_CALENDAR,
            onClick: handleClickNonMySettingsButton,
        },
    };
    return defns;
};

const LeftNavigation = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const appContext = useContext(AppContext);
    const { setPendingAccountSetupMessageDialogOpen } = appContext;
    const profilePicUrl = _get(appContext, 'currentEmployer.profilePicUrl');

    const context = useContext(LayoutContext);
    const { dashboard, setCurrentDashboard } = context;
    // const employerId = _get(appContext, 'employerId');

    const theme = useTheme();
    const lgMatches = useMediaQuery(theme.breakpoints.down('lg'));
    const mdMatches = useMediaQuery(theme.breakpoints.down('md'));

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // useCallback
    //---------------------------------------------------------------------
    const handleClickNonMySettingsButton = useCallback(() => {
        setPendingAccountSetupMessageDialogOpen(true);
    }, [setPendingAccountSetupMessageDialogOpen]);

    //---------------------------------------------------------------------
    // Defns
    //---------------------------------------------------------------------
    const defns = getDefns({ props, profilePicUrl, dashboard, setCurrentDashboard, handleClickNonMySettingsButton });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <div>
            {mdMatches ? null : (
                <div {...defns.root}>
                    <Grid container spacing={1} justify="center">
                        {lgMatches ? null : (
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                                <PhotoSection {...defns.photoSection} />
                            </Grid>
                        )}
                        <Grid item xl={6} lg={12} md={12} sm={12} xs={12}>
                            <NavigationButton {...defns.myProfileButton} />
                        </Grid>
                        <Grid item xl={6} lg={12} md={12} sm={12} xs={12}>
                            <NavigationButton {...defns.myCalendarButton} />
                        </Grid>
                        <Grid item xl={6} lg={12} md={12} sm={12} xs={12}>
                            <NavigationButton {...defns.myJobsButton} />
                        </Grid>
                        <Grid item xl={6} lg={12} md={12} sm={12} xs={12}>
                            <NavigationButton {...defns.myMessagesButton} />
                        </Grid>
                        <Grid item xl={6} lg={12} md={12} sm={12} xs={12}>
                            <NavigationButton {...defns.talentCenterButton} />
                        </Grid>
                        <Grid item xl={6} lg={12} md={12} sm={12} xs={12}>
                            <NavigationButton {...defns.mySettingsButton} />
                        </Grid>
                    </Grid>
                    <span style={{ marginTop: '25px' }}>
                        <Footer />
                    </span>
                </div>
            )}
        </div>
    );
};

export default withStyles(styles)(LeftNavigation);
